export default __webpack_public_path__ + "static/brand_top_2-95ffa8b98dbccbd58bf78f92e9faaa9b.png";